import React, { createContext, type ReactNode, type RefObject, useContext, useMemo } from 'react';

export type AudioPlayerStreamingContextType = {
	fetchAudio: () => Promise<void>;
	audioRef: RefObject<HTMLAudioElement>;
};

export const AudioPlayerStreamingContext = createContext<AudioPlayerStreamingContextType>({
	fetchAudio: async () => {},
	audioRef: { current: null },
});

export type AudioPlayerStreamingProviderProps = {
	fetchAudio: () => Promise<void>;
	audioRef: RefObject<HTMLAudioElement>;
	children: ReactNode;
};

export const AudioPlayerStreamingProvider = ({
	fetchAudio,
	audioRef,
	children,
}: AudioPlayerStreamingProviderProps): React.JSX.Element => {
	const value = useMemo(() => ({ fetchAudio, audioRef }), [fetchAudio, audioRef]);

	return (
		<AudioPlayerStreamingContext.Provider value={value}>
			{children}
		</AudioPlayerStreamingContext.Provider>
	);
};

export const useAudioPlayerStreamingContext = () => {
	return useContext(AudioPlayerStreamingContext);
};
